import React, { useEffect } from "react";
import "./Toast.scss";

export interface ToastProps {
  id: string;
  title: string;
  message: string;
  type?: "success" | "error" | "warning" | "info";
  duration?: number;
  onClose: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({
  id,
  title,
  message,
  type = "success",
  duration = 5000,
  onClose,
}) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose(id);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [id, duration, onClose]);

  const getIconClass = () => {
    switch (type) {
      case "success":
        return "circle-check-icon";
      case "error":
        return "circle-xmark-icon";
      case "warning":
        return "triangle-exclamation-icon";
      case "info":
        return "circle-info-icon";
      default:
        return "circle-check-icon";
    }
  };

  return (
    <div className={`toast toast--${type}`}>
      <div className="toast__content">
        <div className="toast__icon">
          <i className={`f-icon ${getIconClass()}`}></i>
        </div>
        <div className="toast__text">
          <p className="toast__title">{title}</p>
          <p className="toast__message">{message}</p>
        </div>
      </div>
      <button className="toast__close" onClick={() => onClose(id)}>
        <i className="f-icon xmark-icon"></i>
      </button>
    </div>
  );
};

export default Toast;

